import TokenResource from "./TokenResource";
import { InvoiceStatusEnum, InvoiceTypeEnum } from "../utils";

export default class InvoicesResource extends TokenResource {
	id = 0;
	backofficeApplicationId = 0;
	dueDate = "";
	invoiceNumber = "";
	principalAmount = 0;
	principalAmountForDisplay = 0;
	principalAmountIncludingExtraPayments = 0;
	installmentAmount = 0;
	installmentAmountWithFees = 0;
	interestRate = 0.0;
	newInterestRate = 0.0;
	interestAmount = 0;
	status: InvoiceStatusEnum = InvoiceStatusEnum.ToPay;
	termNr = 0;
	termFee = 0;
	invoiceType: InvoiceTypeEnum = InvoiceTypeEnum.TermBill;
	remainingBalance = 0;
	documentJobId = 0;
	daysWithOldInterestRate = 0;
	daysWithNewInterestRate = 0;
	interestRateFromDate = new Date(0);
	interestRateChangeTakesEffectNextTerm = false;

	pk() {
		return this.id.toString();
	}

	static listUrl(
		searchParams?: Readonly<Record<string, string | number>> | undefined
	) {
		if (searchParams && Object.keys(searchParams).length) {
			const { id } = searchParams;
			return `${this.urlRoot}/list/${id}`;
		}
		throw new Error(
			`Couldn't retrieve Invoices with backofficeApplicationId ${
				searchParams ? searchParams.id : null
			}`
		);
	}

	static urlRoot = "/api/invoices";
}
